import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconFillErrorCircle = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--fill-error-circle")} iconColor={color} size={size} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11zM11 7.333v5.334c0 .736.448 1.333 1 1.333s1-.597 1-1.333V7.333C13 6.597 12.552 6 12 6s-1 .597-1 1.333zm1.707 7.96a1 1 0 1 1-1.414 1.414 1 1 0 0 1 1.414-1.414z" fill="currentColor"/>
      <mask id="edovy53xxa" style={{ maskType: "alpha", }} maskUnits="userSpaceOnUse" x="1" y="1" width="22" height="22">
          <path fillRule="evenodd" clipRule="evenodd" d="M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11zM11 7.333v5.334c0 .736.448 1.333 1 1.333s1-.597 1-1.333V7.333C13 6.597 12.552 6 12 6s-1 .597-1 1.333zm1.707 7.96a1 1 0 1 1-1.414 1.414 1 1 0 0 1 1.414-1.414z" fill="#fff"/>
      </mask>
  </IconWrapper>
)
